import { render, staticRenderFns } from "./comp-exit.vue?vue&type=template&id=31052dda&scoped=true&lang=pug&"
import script from "./comp-exit.vue?vue&type=script&lang=js&"
export * from "./comp-exit.vue?vue&type=script&lang=js&"
import style0 from "./comp-exit.vue?vue&type=style&index=0&id=31052dda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31052dda",
  null
  
)

/* custom blocks */
import block0 from "./comp-exit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports